/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

'use strict';

( function() {

	const openButton  = document.querySelectorAll( '[data-menu-trigger]' )[0];
	const closeButton = document.querySelectorAll( '[data-menu-close]' )[0];
	const menu        = document.querySelectorAll( '[data-menu]' )[0];

	openButton.addEventListener( 'click', function( event ) {
		event.preventDefault();
		openMenu( menu );
	});

	closeButton.addEventListener( 'click', function( event ) {
		event.preventDefault();
		closeMenu( menu );
	});

	menu.addEventListener( 'transitionend', function() {
		if ( this.classList.contains( 'hide' ) ) {
			this.classList.remove( 'show', 'hide' );
		}
	});

	/**
	 * Open menu.
	 */
	function openMenu( menu ) {
		menu.classList.add( 'show' );
		menu.setAttribute( 'aria-expanded', 'true' );
	}

	/**
	 * Close menu.
	 */
	function closeMenu( menu ) {
		menu.classList.add( 'hide' );
		menu.setAttribute( 'aria-expanded', 'false' );
	}
}());
